import React, { useContext, useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Box, Grid, TableRow, Typography, makeStyles, Button, InputAdornment, IconButton } from "@material-ui/core";
import TableData, {
  StyledTableCell,
  StyledTableRow,
} from "../icip_admin_screen/components/TableData";
import RaffleDrawService from "../../services/RaffleDrawService";
import Logo from "../../logo.svg";
import FaqService from "../../services/FaqService";
import { Divider } from "antd";
import { VerticalAlignBottom } from "@material-ui/icons";
import { InputField } from "../../components/input-field/InputField";
import { LanguageContext } from "../../context/LanguageContext";
import SearchIcon from "@material-ui/icons/Search";

const useStyles = makeStyles((theme) => ({
  tabHeading: {
    fontWeight: "bold",
    fontSize: 20,
    color: "black",
  },
  tabHeading1: {
    fontWeight: "bold",
    fontSize: 17,
    color: "black",
    width: "30%",
  },
  tabHeading2: {
    fontWeight: "bold",
    fontSize: 17,
    color: "black",
    width: "30%",
  },
  tabHeading3: {
    fontWeight: "bold",
    fontSize: 17,
    color: "black",
    width: "40%",
  },
  searchField: {
    padding: 50,
  },
  generalBox: {
    padding: 25,
  },
  logo: {
    width: 150,
    Height: "auto",
  },
  logoContainer: {
    marginTop: 25,
    textAlign: "center",
    justifyContent: "center",
  },
  mainTitle: {
    fontSize: 40,
    marginLeft: 20,
    marginBottom: 5,
    padding: 5,
    textAlign: "center",
  },
  faqGrid: {
    display: "block",
    padding: 5,
    borderBottom:"0.5px solid"
  },
  faqGridQuestion: {
    fontSize: 18,
  },
  faqGridResponse: {
    fontSize: 15,
  },
  questionResponse: {
    marginTop: 30,
  },
  searchInput: {
    //width: 280,
    margin: 5,
    height: 40,
  },
  searchButton: {
    padding: 10,
    marginTop: 25,
    marginLeft: 15,
  },
  StyledTableRow: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.background.default,
    },
  },
}));

interface PublicFaqsListProps {}

export const PublicFaqsList = (props: PublicFaqsListProps) => {
  const classes = useStyles(props);
  const [error, setError] = useState(false);
  const [faqsTable, setFaqsTable] = useState([]);
  const intl = useIntl();
  const { formatMessage } = useIntl();
  const [searchData, setSearchData] = useState({});

  const fetchAllFaqs = () => {
    FaqService.getAll().then((response) => {
      if (response.isSuccess) {
        switch (response.data.code) {
          case 100:
            let faqsListResult = JSON.parse(JSON.stringify(response.data.data));
            const resultTable = Object.values(faqsListResult);
            setFaqsTable(resultTable);
            break;
          case 110:
            setError(true);
        }
      } else {
        setError(true);
      }
      //setLoading(false);
    });
  };

  useEffect(() => {
    let currentSearchData = { ...searchData };
    currentSearchData["is_public"] = "true";

    setSearchData(currentSearchData);

    fetchAllFaqs();
  }, []);

  const searchFaqs = (data) => {
    FaqService.searchFaqsPublic(data).then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        const faqs = JSON.parse(JSON.stringify(response.data.data));
        setFaqsTable(Object.values(faqs));
      } else {
        
        setError(true);
      }
    })
  };

  const handleDataChange = (name: string, value: string) => {
    let currentSearchData = { ...searchData };
    currentSearchData[name] = value;

    setSearchData(currentSearchData);
    if(value === ""){
      searchFaqs(currentSearchData);
    }
    //searchFaqs(currentSearchData);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      searchFaqs(searchData);
    }
  }

  const locale = useContext(LanguageContext);
  const lang = locale.localeCode;
  //const lang = window.navigator.language;
  const render = () => {
    return (
      <Grid container item xs={12} sm={12} lg={12}>
        <Grid className={classes.logoContainer} item xs={12} sm={12} lg={12}>
          <img className={classes.logo} src={Logo} alt="ICIP Logo" />
        </Grid>
        <Grid item xs={12} sm={12} lg={12}>
          <Typography className={classes.mainTitle} variant="h2" component="h2">
            <FormattedMessage id="sharedScreen.faqList" />
          </Typography>
        </Grid>
        <Grid container item xs={12} sm={12} lg={12}>
          <Grid item xs={12} sm={12} lg={4}>
            <InputField
                className={classes.searchInput}
                fullWidth
                type="text"
                size="medium"
                label={formatMessage({ id: "sharedScreen.faqSearch" })}
                placeholder={formatMessage({ id: "sharedScreen.faqSearchQuestion" })}
                name="faq_search"
                onChange={(event) =>
                  handleDataChange(event.target.name, event.target.value)
                }
                onKeyDown={handleKeyDown}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton edge="end">
                      <SearchIcon onClick={() => searchFaqs(searchData)} />
                    </IconButton>
                  </InputAdornment>
                }
              />
          </Grid>
        </Grid>
        
        <Grid
          className={classes.questionResponse}
          container
          item
          xs={12}
          sm={12}
          lg={12}
        >
          {faqsTable.map((faq, index) => {
            return (
              <>
                {lang === "en" ? (
                  <Grid
                    className={classes.faqGrid}
                    container
                    item
                    xs={12}
                    sm={12}
                    lg={6}
                  >
                    <label className={classes.faqGridQuestion}>
                      <b>
                        <FormattedMessage id="sharedScreen.faqQuestion" />:
                      </b>{" "}
                       {faq.question_en}
                    </label>
                    <br />
                    <i>
                      <label className={classes.faqGridResponse}>
                        <b>
                          <FormattedMessage id="sharedScreen.faqResponse" />:
                        </b>{" "}
                        {faq.response_en}
                      </label>
                    </i>
                  </Grid>
                ) : lang === "fr" ? (
                  <Grid
                    className={classes.faqGrid}
                    container
                    item
                    xs={12}
                    sm={12}
                    lg={6}
                  >
                    <label className={classes.faqGridQuestion}>
                      <b>
                        <FormattedMessage id="sharedScreen.faqQuestion" />:
                      </b>{" "}
                      {faq.question_fr}
                    </label>
                    <br />
                    <i>
                      <label className={classes.faqGridResponse}>
                        <b>
                          <FormattedMessage id="sharedScreen.faqResponse" />:
                        </b>{" "}
                        {faq.response_fr}
                      </label>
                    </i>
                  </Grid>
                ) : (
                  <Grid
                    className={classes.faqGrid}
                    container
                    item
                    xs={12}
                    sm={12}
                    lg={6}
                  >
                    <label className={classes.faqGridQuestion}>
                      <b>
                        <FormattedMessage id="sharedScreen.faqQuestion" />:
                      </b>{" "}
                      {faq.question_en}
                    </label>
                    <br />
                    <i>
                      <label className={classes.faqGridResponse}>
                        <b>
                          <FormattedMessage id="sharedScreen.faqResponse" />:
                        </b>{" "}
                        {faq.response_en}
                      </label>
                    </i>
                  </Grid>
                )}
              </>
            );
          })}
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      <Box className={classes.generalBox} component="div">
        {render()}
      </Box>
    </>
  );
};

PublicFaqsList.routeName = "/public/faqs/list";
